import { render, staticRenderFns } from "./finance_detail.vue?vue&type=template&id=66dd4768&scoped=true&"
import script from "./finance_detail.vue?vue&type=script&lang=js&"
export * from "./finance_detail.vue?vue&type=script&lang=js&"
import style0 from "./finance_detail.vue?vue&type=style&index=0&id=66dd4768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd4768",
  null
  
)

export default component.exports